var _style, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChecked = function SvgChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 731.5 731.5",
    style: {
      enableBackground: "new 0 0 731.5 731.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.8;fill-rule:evenodd;clip-rule:evenodd;fill:#00B5D3;enable-background:new    ;}\n\t.st1{opacity:0.8;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.7,0C163.7,0,0,163.7,0,365.7s163.7,365.7,365.7,365.7s365.7-163.7,365.7-365.7S567.7,0,365.7,0z  M615.8,252.4L317.5,550.7c-9,8.9-23.5,8.9-32.5,0L115.6,381.4c-8.9-8.9-8.9-23.4,0-32.3l39.4-39.4c8.9-8.9,23.4-8.9,32.3,0 l113.9,113.9l243-242.9c8.9-8.9,23.4-8.9,32.3,0l39.4,39.4C624.7,229,624.7,243.4,615.8,252.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M615.8,252.4L317.5,550.7c-9,8.9-23.5,8.9-32.5,0L115.6,381.4c-8.9-8.9-8.9-23.4,0-32.3l39.4-39.4 c8.9-8.9,23.4-8.9,32.3,0l113.9,113.9l243-242.9c8.9-8.9,23.4-8.9,32.3,0l39.4,39.4C624.7,229,624.7,243.4,615.8,252.4z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checked.8d127b13.svg";
export { ForwardRef as ReactComponent };